export default __webpack_public_path__ + "static/media/1.192a0db3.png";